import { ITopPeriodData } from '@/finsight/application/TopCompanies/interfaces';

export const DEFAULT_PERIOD = 'past_12_months';

export const initialTopPeriods: ITopPeriodData = {
  collection: [
    {
      value: 'TTM',
      label: 'TTM',
      dateFrom: null,
      dateTo: null,
    },
  ],
  hasServerError: false,
};
